import {
    useTheme,
    Button,
    useStyles,
    pxArrayToRem,
} from '@archipro-design/aria';
import { AddLine } from '@archipro-design/icons';
import * as S from '~/modules/design-board/component/board-detail/BoardDetailFilter.style';
import { useDesignBoardCollaboratorsContext } from '../../manage/collaborator-overview/context/DesignBoardCollaboratorsContext';
import BoardActionWithLoginPrompt from '@modules/design-board/component/board-detail/BoardActionWithLoginPrompt';
import { useTracker } from '@archipro-website/tracker';

const ShareButton = () => {
    const { css } = useStyles();
    const theme = useTheme();
    const darkOutlinedButtonBorderNormal = `1px solid ${theme.siteVariables.colors.charcoal[250]}`;
    const collaboratorsContext = useDesignBoardCollaboratorsContext();
    const tracker = useTracker();

    const handleClick = () => {
        collaboratorsContext.dispatch({
            type: 'modal-visibility',
            data: {
                visibility: 'visible',
            },
        });
        tracker.log('InviteCollaboratorsReveal', {
            url: new URL(window.location.href),

            data: {
                ElementID:
                    'designboard_detail_header_inviteCollaboratorsReveal',
                Source: 'designBoard, detail',
            },
        });
    };

    return (
        <BoardActionWithLoginPrompt
            action={
                <Button
                    color="dark"
                    iconBefore={<AddLine />}
                    size={16}
                    onClick={handleClick}
                    variables={{
                        buttonPadding: pxArrayToRem([16, 14, 16, 20]),
                        iconPadding: 4,
                        darkOutlinedButtonBorderNormal,
                    }}
                    variant="outlined"
                    className={css(S.ShareButton)}
                >
                    SHARE
                </Button>
            }
        />
    );
};

export default ShareButton;
